const REPORTS_DOMAIN = 'reports'
const REPORTS_STATE = {
  /**
   * A mapping of `Comment` id to `DomainList`.
   *
   * @example
   *
   * ```js
   *
   * reports : {
   *
   *   comments : {
   *     30 : {
   *        data : [1, 2, 3],
   *     }
   *   }
   *
   *   data : {
   *
   *    1 : {
   *      className : 'Report',
   *      data      : {
   *        ...
   *      },
   *      ...
   *    }
   *
   *   }
   *
   * }
   *
   * ```
   *
   * @type {Object}
   */
  comments: {},
  /**
   * A mapping of `Report`'s id to `Instance`.
   * @type {Object}
   */
  data: {}
}

const REPORTS_PATH = {
  DATA: `${REPORTS_DOMAIN}.data`,
  COMMENTS: `${REPORTS_DOMAIN}.comments`
}

export {
  REPORTS_DOMAIN,
  REPORTS_STATE,
  REPORTS_PATH
}
